import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app/environment/environment';
import type { ContactRequest } from '@app/models/account.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly API_URL = environment.apiUrl;
  constructor(private http: HttpClient) {}

  // PC ZRT. CONTACTS - new api comes - change it
  // TODO: contact list - modify api
  getContacts(): Observable<any> {
    return this.http.get(`${this.API_URL}/users`);
  }
  // TODO: get contact by id - modify api
  getContactById(id: string): Observable<any> {
    return this.http.get(`${this.API_URL}/user/${id}`);
  }
  // TODO: add new contact - modify api
  addContact(payload: ContactRequest): Observable<ContactRequest> {
    return this.http.post<any>(`${this.API_URL}/Contact`, payload);
  }

  // details
  // TODO: header - reset password - modify api ??
  requestPasswordReset(email: string): Observable<void> {
    return this.http.post<void>(`${this.API_URL}/Account/ForgotPassword`, {
      email,
    });
  }
  // TODO: header - suspend - modify api
  deactivateContact(id: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/User/${id}/Deactivate`, {});
  }
  reactivateContact(id: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/User/${id}/Reactivate`, {});
  }
  // TODO: header - delete - modify api
  deleteContact(id: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/User/${id}`);
  }
  // TODO: save contact - modify api
  saveContact(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.API_URL}/User/${id}`, payload);
  }
  // TODO: project list (+filter)
}
